module.exports = __webpack_public_path__ + "img/home_icon_5.8d0bd07f.png";